import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SupportButtonService } from '@app/gui/support-button.service';
import { ConfigStore } from './app-configs/config-store';
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
	public title:string;
	public favIcon: HTMLLinkElement = document.querySelector('#appIcon');

	constructor(
		private readonly iconRegistry: MatIconRegistry,
		private readonly sanitizer: DomSanitizer,
		public readonly supportButton:SupportButtonService
	) {
	}

	ngOnDestroy(): void {
	}

	ngOnInit(): void {
		this.title=ConfigStore.get<string>('branding.vendor') ?? '';

		this.iconRegistry.registerFontClassAlias("symbol","material-symbols-outlined");
		this.iconRegistry.setDefaultFontSetClass("material-icons-outlined");

		// this.iconRegistry.addSvgIcon('brandLogo', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/new-strayos.svg'));
		// this.iconRegistry.addSvgIcon('brandBlackLogo', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/strayos.svg'));
		// this.iconRegistry.addSvgIcon('brandBlueLogo', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/strayos-blue-logo.svg'));
		this.iconRegistry.addSvgIcon('blastDesign', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/BlastDesign.svg'));
		this.iconRegistry.addSvgIcon('blastPerformance', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/blast-performance.svg'));
		this.iconRegistry.addSvgIcon('pdfIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/pdf.svg'));
		this.iconRegistry.addSvgIcon('cost', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/cost.svg'));
		this.iconRegistry.addSvgIcon('database', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/database.svg'));
		this.iconRegistry.addSvgIcon('drillKPI', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/drilling-KPI.svg'));
		this.iconRegistry.addSvgIcon('operationaldata', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/operational-data.svg'));
		this.iconRegistry.addSvgIcon('overview', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/overview.svg'));
		this.iconRegistry.addSvgIcon('downloadIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/download-options.svg'));
		this.iconRegistry.addSvgIcon('fullScreenIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/Vector.svg'));
		this.iconRegistry.addSvgIcon('tableViewIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/table-view.svg'));
		this.iconRegistry.addSvgIcon('odcIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/ODC.svg'));
		this.iconRegistry.addSvgIcon('addIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/add.svg'));
		this.iconRegistry.addSvgIcon('downloadSampleIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/download-sample.svg'));
		this.iconRegistry.addSvgIcon('exportIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/Export.svg'));
		this.iconRegistry.addSvgIcon('importIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/Import.svg'));
		this.iconRegistry.addSvgIcon('excelIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/xls.svg'));
		this.iconRegistry.addSvgIcon('csvIcon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/csv.svg'));
		this.iconRegistry.addSvgIcon('google-icon',this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/google-icon.svg'));
		this.iconRegistry.addSvgIcon('microsoft-icon',this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/microsoft-icon.svg'));
		this.iconRegistry.addSvgIcon('overview-icon',this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/state_active1.svg'));
		this.iconRegistry.addSvgIcon('keymetrics-icon',this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/state_active2.svg'));
		this.iconRegistry.addSvgIcon('costs-icon',this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/state_active3.svg'));
		this.iconRegistry.addSvgIcon('empty-icon',this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/no-data.svg'));
		this.iconRegistry.addSvgIcon('login-icon', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/dashboard-login.svg'));
		this.iconRegistry.addSvgIcon('inventoryDashboard', this.sanitizer.bypassSecurityTrustResourceUrl('assets/mat-icons/inventory-dashboard.svg'));
	}
}
